import { createContext, useContext } from 'react'
import type { AuthMutationsLoginArgs } from './internal/useGenerateAuthenticateAction'

export type ApiAuthActionsState = {
  authenticate: (variables: AuthMutationsLoginArgs) => Promise<string | null>
  clear: () => void
  fetchAccessToken: (force?: boolean) => Promise<string | null>
  switchOrganization: (tid: number) => Promise<string | null>
  getAccessToken: () => string | null
  getRefreshToken: () => string | null
  isAuthenticated: () => boolean
}

const ApiAuthActionsContext = createContext<ApiAuthActionsState>({
  authenticate: async () => null,
  clear: () => {},
  fetchAccessToken: async () => null,
  switchOrganization: async () => null,
  getAccessToken: () => null,
  getRefreshToken: () => null,
  isAuthenticated: () => false,
})

export const ApiAuthActionsProvider = ApiAuthActionsContext.Provider

export const useApiAuthActions = () => useContext(ApiAuthActionsContext)
